import React, { useContext } from 'react'

import { LangContext } from 'context'
import { DEFAULT_LANG } from 'config/languages'
import { Row, Column } from 'components/Grid'
import Link from 'components/Link'
import Markdown from 'components/Markdown'
import MainLogo from 'components/elements/MainLogo'
import FontAwesome from 'components/FontAwesome'

import {
   StyledFooter,
   StyledMenusWrapper,
   StyledMainMenu,
   StyledSmallMenu,
   StyledInfoWrapper,
   StyledCopyWrapper,
   StyledLogo,
   StyledMainLogo,
   StyledLinksLabel,
   StyledContainer,
} from './styles'

export default function Footer({ menu, smallMenu, thirdMenu, textContent, copyText, copyTitle }) {
   const { lang, path } = useContext(LangContext)

   return (
      <StyledFooter>
         <StyledContainer>
            <Row justifyContent={'space-between'}>
               <Column width={[1, 1, 1, 1, 1/2]} order={[1, 1, 1, 1, 1]}>
                  <StyledMenusWrapper>
                     <StyledMainLogo>
                        <MainLogo lang={lang} />
                     </StyledMainLogo>

                     <StyledMainMenu>
                        <StyledLinksLabel>About</StyledLinksLabel>

                        {Array.isArray(menu) &&
                           menu.map((el) => {
                              if (el.type === 'internal') {
                                 const linkUrl = lang === DEFAULT_LANG ? el.url : `/${lang}${el.url}`
                                 return (
                                    <li key={el.id}>
                                       <Link {...el} url={linkUrl} title={undefined}>
                                          {el.title}
                                          <FontAwesome icon="arrowRight" />
                                       </Link>
                                    </li>
                                 )
                              }
                              return (
                                 <li key={el.id}>
                                    <Link type={el.type} url={el.url} title={undefined}>
                                       {el.title}
                                       <FontAwesome icon="arrowRight" />
                                    </Link>
                                 </li>
                              )
                           })}
                     </StyledMainMenu>

                     <StyledSmallMenu>
                        <StyledLinksLabel>Company</StyledLinksLabel>

                        {Array.isArray(smallMenu) &&
                           smallMenu.map((el) => {
                              if (el.type === 'internal') {
                                 const linkUrl = lang === DEFAULT_LANG ? el.url : `/${lang}${el.url}`
                                 return (
                                    <li key={el.id}>
                                       <Link {...el} url={linkUrl} title={undefined}>
                                          {el.title}
                                          <FontAwesome icon="arrowRight" />
                                       </Link>
                                    </li>
                                 )
                              }
                              return (
                                 <li key={el.id}>
                                    <Link type={el.type} url={el.url} title={undefined}>
                                       {el.title}
                                       <FontAwesome icon="arrowRight" />
                                    </Link>
                                 </li>
                              )
                           })}
                     </StyledSmallMenu>

                     <StyledSmallMenu>
                        <StyledLinksLabel>Overview</StyledLinksLabel>

                        {Array.isArray(thirdMenu) &&
                           thirdMenu.map((el) => {
                              if (el.type === 'internal') {
                                 const linkUrl = lang === DEFAULT_LANG ? el.url : `/${lang}${el.url}`
                                 return (
                                    <li
                                       key={el.id}
                                       className={
                                          linkUrl.includes('#') && linkUrl.indexOf(`${path}#`) >= 0 ? 'active' : ''
                                       }
                                    >
                                       <Link {...el} url={linkUrl} title={undefined}>
                                          {el.title}
                                          <FontAwesome icon="arrowRight" />
                                       </Link>
                                    </li>
                                 )
                              }
                              return (
                                 <li key={el.id}>
                                    <Link type={el.type} url={el.url} title={undefined}>
                                       {el.title}
                                       <FontAwesome icon="arrowRight" />
                                    </Link>
                                 </li>
                              )
                           })}
                     </StyledSmallMenu>
                  </StyledMenusWrapper>
               </Column>

               <Column width={[1, 1, 1, '478px', 1/2]} order={[2, 2, 2, 2, 2]}>
                  <StyledInfoWrapper>
                     {textContent && textContent.markdown && <Markdown>{textContent.markdown}</Markdown>}
                  </StyledInfoWrapper>
               </Column>

               <Column width={[1]} order={[3, 3, 3, 3]}>
                  <StyledCopyWrapper>
                     <div>
                        <StyledLogo />
                        <span>{copyTitle}</span>
                     </div>

                     <p>{copyText?.markdown}</p>
                  </StyledCopyWrapper>
               </Column>
            </Row>
         </StyledContainer>
      </StyledFooter>
   )
}
